import messages from './messages';
import { COUNTRY_SHORT_NAMES } from 'config/constants';

export const defaultLocale = 'en-US';
export const supportedLocales = Object.keys(messages);

export function getMessagesForLocale(locale) {
	return messages[locale] || messages[defaultLocale];
}

export function getDefaultLocale(country) {
	if (country && country !== COUNTRY_SHORT_NAMES.CA) {
		return defaultLocale;
	}
	const storageLocale = sessionStorage.getItem('currentLocale');
	const locale = storageLocale ? storageLocale : navigator.locale;
	return supportedLocales.includes(locale) ? locale : defaultLocale;
}

export function getContactInformation(country, isFromOrderHistory) {
	switch (country) {
		case COUNTRY_SHORT_NAMES.US:
		case COUNTRY_SHORT_NAMES.CA:
			if (isFromOrderHistory) {
				return {
					phoneNumber: '1-877-762-7662',
					emailAddress: 'help@snapon.com',
				};
			}
			return {
				phoneNumber: '1-877-762-7668',
				emailAddress: 'help@snapon.com',
			};
		case COUNTRY_SHORT_NAMES.UK:
		case COUNTRY_SHORT_NAMES.IE:
			return {
				phoneNumber: '01536 413838',
				emailAddress: 'chrome.uk@snapon.com',
			};
		case COUNTRY_SHORT_NAMES.AU:
		case COUNTRY_SHORT_NAMES.NZ:
			return {
				phoneNumber: '+61 2 9837 9166',
				emailAddress: 'sota.customerservice@snapon.com',
			};
		default:
			if (isFromOrderHistory) {
				return {
					phoneNumber: '1-877-762-7662',
					emailAddress: 'help@snapon.com',
				};
			}

			return {
				phoneNumber: '1-877-762-7668',
				emailAddress: 'help@snapon.com',
			};
	}
}



// WEBPACK FOOTER //
// ./src/ui/i18n/helpers.js